import { useRef, useState, useEffect } from "react";
import {
    dropTargetForElements,
} from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { combine } from '@atlaskit/pragmatic-drag-and-drop/combine';
import { getDropAreaDropData } from "./dragAndDropHelpers";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

export function EmptySubtypesDropArea() {
    const { t } = useTranslation();

    const ref = useRef<HTMLDivElement>(null);

    const [isDraggedOn, setIsDraggedOn] = useState(false);

    useEffect(() => {
        const element = ref.current!;

        const data = getDropAreaDropData();

        return combine(
            dropTargetForElements({
                element,
                getData: () => data,
                onDragEnter: () => setIsDraggedOn(true),
                onDragLeave: () => setIsDraggedOn(false),
                onDrop: () => setIsDraggedOn(false),
            }),
        )
    }, []);

    return <div ref={ref}>
        <Box sx={{
            p: 3,
            margin: "10px",
            borderColor: "#b2b2b2",
            borderWidth: "2px",
            borderStyle: "dashed",
            borderRadius: "4px",
            padding: "30px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            textAlign: "center",
            opacity: isDraggedOn ? 0.5 : 1
        }}>
            {t("actionModuleEditor.tabSubtypes.emptyState")}
        </Box>
    </div>
}